import React from "react";
import { Input, Select } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { Supplier } from "../../../Types";

const { Option } = Select;

interface Props {
  searchInput: string;
  onSearchChange: (v: string) => void;
  supplierId: string | null;
  onSupplierChange: (v: string | null) => void;
  suppliers: Supplier[];
}

export const RawMaterialsFilters: React.FC<Props> = ({
  searchInput,
  onSearchChange,
  supplierId,
  onSupplierChange,
  suppliers,
}) => (
  <div className="flex flex-wrap items-center gap-2">
    <Input
      placeholder="Search by name or code"
      prefix={<SearchOutlined />}
      value={searchInput}
      onChange={(e) => onSearchChange(e.target.value)}
      allowClear
      className="w-full sm:w-56"
    />
    <Select
      placeholder="Filter by supplier"
      value={supplierId}
      onChange={onSupplierChange}
      className="w-full sm:w-48"
      allowClear
    >
      {suppliers.map((s) => (
        <Option key={s.id} value={s.id}>
          {s.name}
        </Option>
      ))}
    </Select>
  </div>
);
